/**
 * Whether clicking or typing in the field may open the dropdown. A deferred dropdown (the combined
 * procedure codes search) opens only once there is something to show: options, or the
 * explanation that the filter hid every match.
 */
export function canOpenDropdown({
  defersDropdownUntilSearch,
  optionCount,
  isEverythingFilteredOut,
  hasFilteredOutMessage,
}: {
  defersDropdownUntilSearch: boolean;
  optionCount: number;
  isEverythingFilteredOut: boolean;
  hasFilteredOutMessage: boolean;
}): boolean {
  if (!defersDropdownUntilSearch) return true;
  return optionCount > 0 || (isEverythingFilteredOut && hasFilteredOutMessage);
}
